import { render, staticRenderFns } from "./basic-data-visualizer-small.vue?vue&type=template&id=c8b5a278&scoped=true&"
import script from "./basic-data-visualizer-small.vue?vue&type=script&lang=js&"
export * from "./basic-data-visualizer-small.vue?vue&type=script&lang=js&"
import style0 from "./basic-data-visualizer-small.vue?vue&type=style&index=0&id=c8b5a278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b5a278",
  null
  
)

export default component.exports